export default __webpack_public_path__ + "static/media/mobile-header.00fe382b.svg";